export const ROUTES = {
	APP: {
		LOGIN_FLOW: '/app/login-flow',
		ROOT: '/app',
		NEW_STUDENT: '/app/new-student',
		TRAININGS: '/app/trainings',
		REPORTING: '/app/reporting',
		REPORTING_DETAIL: '/app/reporting/detail',
		TEACHER_STATISTICS: '/app/teacher-statistics',
		EXAMS: '/app/exams',
		EXAMS_DETAIL: '/app/exams/detail',
		EXAMS_RESULTS: '/app/exams/results',
		SUPPORT: '/app/support',
		SETTINGS: '/app/settings',
		STUDENT_CARD: '/app/student',
		DEBUG: '/app/debug',
		MORE: '/app/more',
		TIER: '/app/tier',
		TEACHERS: '/app/teachers',
		USER_SETTINGS: '/app/user-settings',
		APPLICATION_FORM: '/app/application-form',
		GROUP_BLOCKED: '/app/group-blocked',
		INTERPRETER: '/app/interpreter',
		SEARCH: '/app/search',
		CALENDAR: '/app/calendar',
		//
		SUB_GROUP_BLOCKED: 'group-blocked',
		SUB_LOGIN_FLOW: 'login-flow',
		SUB_NEW_STUDENT: 'new-student',
		SUB_CALENDAR: 'calendar',
		SUB_TRAININGS: 'trainings',
		SUB_REPORTING: 'reporting',
		SUB_REPORTING_DETAIL: 'reporting/detail',
		SUB_TEACHER_STATISTICS: 'teacher-statistics',
		SUB_EXAMS: 'exams',
		SUB_EXAMS_DETAIL: 'exams/detail',
		SUB_EXAMS_RESULTS: 'exams/results',
		SUB_SUPPORT: 'support',
		SUB_SETTINGS: 'settings',
		SUB_STUDENT: 'student',
		SUB_DEBUG: 'debug',
		SUB_MORE: 'more',
		SUB_TIER: 'tier',
		SUB_TEACHERS: 'teachers',
		SUB_USER_SETTINGS: 'user-settings',
		SUB_APPLICATION_FORM: 'application-form',
		SUB_INTERPRETER: 'interpreter',
	},
	OUT_APP: {
		LOGIN: '/login',
		REGISTER: '/register',
		CONFIR_REGISTRATION_CODE: '/email-confirm',
		RESET_PASSWORD: '/reset-password',
		RESET_PASSWORD_CONFIRM: '/reset-password-confirm',

		SUB_CONFIR_REGISTRATION_CODE: 'email-confirm',
		SUB_LOGIN: 'login',
		SUB_REGISTER: 'register',
		SUB_RESET_PASSWORD: 'reset-password',
		SUB_RESET_PASSWORD_CONFIRM: 'reset-password-confirm',
		SUB_SCHOOL_INVITE_CONFIRM: 'school-invite-confirm',

		DOC: '/doc',
		CONTACT: '/contact',

		// student pass
		STUDENT: '/student',
	},
};
